<template>
  <head>
    <meta charset="utf-8"/>
    <title>Desk Birdy | Business Permits</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->

    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

  </head>

  <body @contextmenu.prevent data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>
    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">ACTIVE CERTIFICATES</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Certificates & Licenses</a></li>
                    <li class="breadcrumb-item"><a href="cert-biz-stats.html">Business Permits</a></li>
                    <li class="breadcrumb-item active">Active Certificates</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Businesses</p>
                      <h4 class="mb-0">{{ numberFormat(totalBusiness) }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                        <span class="avatar-title">
                          <i class="bx bx-store font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Amount</p>
                      <h4 class="mb-0">KES {{ numberFormat(totalAmount) }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                        <span class="avatar-title">
                          <i class="bx bx-money font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Active Records</p>
                      <h4 class="mb-0">{{ pendingInvoicing.length }}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                        <span class="avatar-title">
                          <i class="bx bx-check-double font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Status</p>
                      <h4 class="mb-0 text-success">Active</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                        <span class="avatar-title">
                          <i class="bx bx-check-circle font-size-24"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- tool bar -->
          <ToolBarHygiene/>
          <!-- end of toolbar -->

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">

                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100"
                       role="toolbar">
                    <h4 class="card-title mb-0 text-uppercase">
                      <i class="bx bx-list-check me-2"></i>BUSINESSES WITH ACTIVE HYGIENE PERMITS
                    </h4>
                    <div>
                      <button @click="showExportModal = true" class="btn btn-success btn-sm me-2">
                        <i class="bx bx-download me-1"></i> Export CSV
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-header bg-light pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="d-flex align-items-center justify-content-between p-3 w-100">
                    <div class="flex-grow-1 me-3">
                      <form class="app-search p-0 m-0">
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control"
                                 placeholder="Search by Business Name, ID, Bill Number, or Officer Name..."
                                 spellcheck="false" data-ms-editor="true">
                          <span class="bx bx-search-alt"></span>
                        </div>
                      </form>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="me-2">
                        <input
                            type="date"
                            v-model="filterDateRange.startDate"
                            class="form-control form-control-sm"
                            placeholder="Start Date"
                            @change="applyDateFilter"
                            title="Filter by start date"
                        />
                      </div>
                      <div class="me-2">
                        <input
                            type="date"
                            v-model="filterDateRange.endDate"
                            class="form-control form-control-sm"
                            placeholder="End Date"
                            @change="applyDateFilter"
                            title="Filter by end date"
                        />
                      </div>
                      <div class="me-2" v-if="filterDateRange.startDate || filterDateRange.endDate">
                        <button
                            @click="clearDateFilter"
                            class="btn btn-sm btn-outline-danger"
                            title="Clear date filter"
                        >
                          <i class="bx bx-x"></i>
                        </button>
                      </div>
                      <div class="me-2">
                        <select v-model="selectedFilter" class="form-select form-select-sm">
                          <option value="">All Categories</option>
                          <option value="Canteens">Canteens</option>
                          <option value="Bars">Bars/Pubs</option>
                          <option value="Category B Hotels">Hotels</option>
                          <option value="Eating House">Eating House</option>
                          <option value="Food Wholesale">Food Wholesale</option>
                        </select>
                      </div>
                      <div>
                        <select v-model="pageSize" class="form-select form-select-sm">
                          <option value="10">10 per page</option>
                          <option value="25">25 per page</option>
                          <option value="50">50 per page</option>
                          <option value="100">100 per page</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Active Filter Indicator -->
                <div v-if="filterDateRange.startDate || filterDateRange.endDate" class="card-body py-2 bg-light border-bottom">
                  <div class="d-flex align-items-center">
                    <i class="bx bx-filter-alt text-primary me-2"></i>
                    <small class="text-muted">
                      <strong>Date Filter Active:</strong>
                      {{ filterDateRange.startDate || 'Any' }} to {{ filterDateRange.endDate || 'Any' }}
                    </small>
                    <button @click="clearDateFilter" class="btn btn-link btn-sm ms-auto text-danger">
                      Clear Filter
                    </button>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2">Loading business data...</p>
                  </div>

                  <!-- Table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover table-nowrap mb-0">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" @change="selectAll">
                          </div>
                        </th>
                        <th scope="col">Business Details</th>
                        <th scope="col">Location</th>
                        <th scope="col">Invoice Info</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Status</th>
                        <th scope="col">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in paginatedData" :key="index"
                          class="hover-row" :class="{'selected-row': selectedItems.includes(item.billNo)}">
                        <td>
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox"
                                   v-model="selectedItems" :value="item.billNo">
                          </div>
                        </td>
                        <td>
                          <div>
                            <h6 class="mb-1">
                              <a href="javascript:void(0)" @click="getBusiness(item)" class="text-dark">
                                {{ item.businessName }}
                              </a>
                            </h6>
                            <span class="text-muted small">
                              <i class="bx bx-id-card me-1"></i>ID: {{ item.businessID }}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <p class="text-muted mb-0">
                              <i class="bx bx-building-house me-1"></i>{{ item.feeDescription }}
                            </p>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span class="badge bg-info-subtle text-info font-size-12 mb-1">
                              {{ item.billNo }}
                            </span>
                            <p class="text-muted mb-0 small">
                              <i class="bx bx-calendar me-1"></i>{{ formatDate(item.dateCreated) }}
                            </p>
                            <p class="text-muted mb-0 small">
                              <i class="bx bx-time-five me-1"></i>{{ formatTimeAgo(item.dateCreated) }}
                            </p>
                          </div>
                        </td>
                        <td>
                          <div>
                            <h5 class="font-size-14 mb-1 text-dark">
                              KES {{ numberFormat(item.billTotal) }}
                            </h5>
                            <span class="text-muted small">
                              By: {{ item.names }}
                            </span>
                          </div>
                        </td>
                        <td>
                          <span class="badge" :class="getStatusBadgeClass(item.stageStatus)">
                            {{ item.stageStatus || 'Active' }}
                          </span>
                        </td>
                        <td>
                          <div class="d-flex gap-1">
                            <button @click="getBusiness(item)"
                                    class="btn btn-soft-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target=".receipting-modal"
                                    title="View Details">
                              <i class="bx bx-show"></i>
                            </button>

                            <button @click="printBill(item.billNo)"
                                    class="btn btn-soft-success btn-sm"
                                    title="Print Invoice">
                              <i class="bx bx-printer"></i>
                            </button>

                            <button @click="printPermit(item.businessID)"
                                    class="btn btn-soft-info btn-sm"
                                    title="Print Certificate">
                              <i class="mdi mdi-certificate-outline"></i>
                            </button>

                            <div class="dropdown">
                              <button class="btn btn-soft-secondary btn-sm"
                                      type="button" data-bs-toggle="dropdown">
                                <i class="bx bx-dots-vertical-rounded"></i>
                              </button>
                              <ul class="dropdown-menu dropdown-menu-end">
                                <li>
                                  <a @click="getBusinessDetails(item.businessID,item.billNo,item.feeID)"
                                     class="dropdown-item" href="javascript:void(0);"
                                     data-bs-target=".receipting-modal" data-bs-toggle="modal">
                                    <i class="bx bx-show me-2"></i>View Details
                                  </a>
                                </li>
                                <li v-if="getRight('FOOD HYGIENE TOP UP')">
                                  <a @click="openTopUpModal(item.businessID,item.billNo,item.feeID)"
                                     class="dropdown-item" href="javascript:void(0);"
                                     data-bs-toggle="modal" data-bs-target="#topUpModal">
                                    <i class="bx bxs-upvote me-2"></i>Top Up
                                  </a>
                                </li>
                                <li><hr class="dropdown-divider"></li>
                                <li>
                                  <a @click="sendSMS(item)" class="dropdown-item" href="javascript:void(0);">
                                    <i class="bx bx-message-square-dots me-2"></i>Send SMS
                                  </a>
                                </li>
                                <li>
                                  <a @click="sendEmail(item)" class="dropdown-item" href="javascript:void(0);">
                                    <i class="bx bx-envelope me-2"></i>Send Email
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- No Data State -->
                    <div v-if="!loading && pendingInvoicing.length === 0" class="text-center py-5">
                      <i class="bx bx-search-alt font-size-64 text-muted"></i>
                      <h5 class="mt-3">No Active Hygiene Permits Found</h5>
                      <p class="text-muted">Try adjusting your search or filter criteria</p>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div v-if="totalPages > 1" class="row mt-4">
                    <div class="col-sm-12 col-md-5">
                      <div class="dataTables_info">
                        Showing {{ showingStart }} to {{ showingEnd }} of {{ totalRecords }} entries
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-7">
                      <nav aria-label="Page navigation">
                        <ul class="pagination pagination-rounded justify-content-end mb-0">
                          <li class="page-item" :class="{ disabled: !hasPreviousPage }">
                            <a class="page-link" href="javascript:void(0)" @click="previousPage">
                              <i class="mdi mdi-chevron-left"></i>
                            </a>
                          </li>
                          <li v-for="page in displayedPages" :key="page"
                              class="page-item" :class="{ active: page === currentPage }">
                            <a class="page-link" href="javascript:void(0)" @click="goToPage(page)">
                              {{ page }}
                            </a>
                          </li>
                          <li class="page-item" :class="{ disabled: !hasNextPage }">
                            <a class="page-link" href="javascript:void(0)" @click="nextPage">
                              <i class="mdi mdi-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>

                <!-- Footer Summary -->
                <div class="card-footer bg-light">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <div v-if="selectedItems.length > 0" class="d-flex align-items-center">
                        <span class="badge bg-primary me-2">{{ selectedItems.length }} Selected</span>
                        <button @click="bulkPrintInvoices" class="btn btn-sm btn-outline-primary me-2">
                          <i class="bx bx-printer me-1"></i>Print Selected
                        </button>
                        <button @click="bulkSendSMS" class="btn btn-sm btn-outline-success">
                          <i class="bx bx-message me-1"></i>Send SMS
                        </button>
                      </div>
                    </div>
                    <div class="col-md-6 text-end">
                      <span class="text-muted me-3">
                        <strong>Total Businesses:</strong> {{ numberFormat(totalBusiness) }}
                      </span>
                      <span class="text-success fw-bold">
                        <strong>Total Amount:</strong> KES {{ numberFormat(totalAmount) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Export Modal -->
      <div class="modal fade" id="exportModal" tabindex="-1" v-if="showExportModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <i class="bx bx-download me-2"></i>Export to CSV
              </h5>
              <button type="button" class="btn-close" @click="closeExportModal"></button>
            </div>

            <div class="modal-body">
              <div class="export-options">
                <div class="form-check mb-3 p-3 border rounded" :class="{'bg-light': exportType === 'current'}">
                  <input class="form-check-input" type="radio" v-model="exportType" value="current" id="exportCurrent">
                  <label class="form-check-label w-100" for="exportCurrent">
                    <strong>Export Current Page</strong>
                    <p class="text-muted mb-0 small">{{ paginatedData.length }} records on this page</p>
                  </label>
                </div>

                <div class="form-check mb-3 p-3 border rounded" :class="{'bg-light': exportType === 'all'}">
                  <input class="form-check-input" type="radio" v-model="exportType" value="all" id="exportAll">
                  <label class="form-check-label w-100" for="exportAll">
                    <strong>Export All Records</strong>
                    <p class="text-muted mb-0 small">{{ numberFormat(totalRecords) }} total records</p>
                  </label>
                </div>

                <div class="form-check mb-3 p-3 border rounded" :class="{'bg-light': exportType === 'dateRange'}">
                  <input class="form-check-input" type="radio" v-model="exportType" value="dateRange" id="exportDateRange">
                  <label class="form-check-label w-100" for="exportDateRange">
                    <strong>Export by Date Range</strong>
                    <p class="text-muted mb-0 small">Select custom date range</p>
                  </label>

                  <div v-if="exportType === 'dateRange'" class="mt-3">
                    <div class="row g-2">
                      <div class="col-md-6">
                        <label class="form-label small">Start Date</label>
                        <input type="date" v-model="dateRange.startDate" class="form-control form-control-sm">
                      </div>
                      <div class="col-md-6">
                        <label class="form-label small">End Date</label>
                        <input type="date" v-model="dateRange.endDate" class="form-control form-control-sm">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeExportModal">Cancel</button>
              <button type="button" class="btn btn-success" @click="startExport" :disabled="isExporting">
                <i class="bx bx-download me-1"></i>
                {{ isExporting ? 'Exporting...' : 'Export' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Export Progress Modal -->
      <div class="modal fade" id="exportProgressModal" tabindex="-1" v-if="showProgressModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <i class="bx bx-loader-alt bx-spin me-2"></i>Exporting Data
              </h5>
            </div>

            <div class="modal-body">
              <div class="progress mb-3" style="height: 30px;">
                <div class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                     role="progressbar"
                     :style="{ width: exportProgress.percentage + '%' }">
                  <strong>{{ exportProgress.percentage }}%</strong>
                </div>
              </div>

              <div class="export-info">
                <p class="mb-2">
                  <i class="bx bx-data me-2"></i>
                  <strong>Progress:</strong> {{ numberFormat(exportProgress.current) }} / {{ numberFormat(exportProgress.total) }} records
                </p>
                <p class="mb-2">
                  <i class="bx bx-time me-2"></i>
                  <strong>Estimated Time:</strong> {{ exportProgress.timeRemaining }}
                </p>
                <p class="mb-0" v-if="exportProgress.currentBatch">
                  <i class="bx bx-package me-2"></i>
                  <strong>Processing:</strong> Batch {{ exportProgress.currentBatch }} of {{ exportProgress.totalBatches }}
                </p>
              </div>
            </div>

            <div class="modal-footer" v-if="exportProgress.canCancel">
              <button type="button" class="btn btn-danger" @click="cancelExport">
                <i class="bx bx-x me-1"></i>Cancel Export
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Components -->
      <BusinessDetailsModal
          :business-details="businessDetails"
          :bill-details="billDetails"
          @show-payment-modal="showPaymentMethod"
          @print-invoice="printBill"
          @print-receipt="printReceipt"
      />

      <InvoiceSMSModal
          :business="business"
          :bill-detail="billDetail"
          @resend-message="resendMessage"
      />

      <TopUpModal
          :business-details="businessDetails"
          :sub-counties="subCounties"
          :wards="wards"
          :income-types="incomeTypes"
          :fees-and-chargess="feesAndChargess"
          :fees-and-charges-others="feesAndChargesOthers"
          :fees-and-charges="feesAndCharge"
          :loading="loading"
          :bill-created="billCreated"
          :bill-details="billDetails"
          @view-business="viewBusiness"
          @get-wards="getWards"
          @get-fees-and-charges="getFeesAndCharges"
          @calculate-total="calculateTotal"
          @update-business-top-up="updateBusinessTopUp"
          @print-bill="printBill2"
          @update-checked-items="updateCheckedItems"
      />

      <PaymentModal
          :bill-details="billDetails"
          :payment-data="paymentData"
          :payment-method="paymentMethod"
          :transaction-summary="transactionSummary"
          :transaction-completed="transactionCompleted"
          :receipt-details="receiptDetails"
          :message="message"
          :phone-number="phoneNumber"
          @show-transaction-summary="handleShowTransactionSummary"
          @make-payment="handleMakePayment"
          @print-receipt="printReceipt"
          @update-phone-number="updatePhoneNumber"
      />

      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">

            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-none d-sm-block ">
                Developed by
                <a href="https://www.nouveta.tech/" target="_blank">
                  <img src="assets/images/nouveta.png " alt=" " height="18 ">
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ToolBarFire from "@/components/fire/ToolBarFire.vue";
import ToolBarHygiene from "@/components/hygiene/ToolBarHygiene.vue";
import moment from "moment/moment";
import {execute, fire, biller, trade, health, getRight, authUrl, parking, rent} from "@/api";

// Import the new modal components
import BusinessDetailsModal from "./modals/BusinessDetailsModal.vue";
import InvoiceSMSModal from "./modals/InvoiceSMSModal.vue";
import TopUpModal from "./modals/TopUpModal.vue";
import PaymentModal from "./modals/PaymentModal.vue";

export default {
  name: "ActiveHygieneCert",
  components: {
    ToolBarHygiene,
    ToolBarFire,
    NavigationBar,
    BusinessDetailsModal,
    InvoiceSMSModal,
    TopUpModal,
    PaymentModal
  },

  data() {
    return {
      message: null,
      businessDetails: {
        id: null,
        businessID: null,
        businessName: null,
        subCountyID: null,
        subCountyName: null,
        wardID: null,
        wardName: null,
        plotNumber: null,
        physicalAddress: null,
        buildingName: null,
        buildingOccupancy: null,
        floorNo: null,
        roomNo: null,
        premiseSize: null,
        numberOfEmployees: null,
        tonnage: null,
        businessDes: null,
        businessCategory: null,
        businessSubCategory: null,
        incomeTypeID: null,
        feeID: null,
        businessEmail: null,
        postalAddress: null,
        postalCode: null,
        businessPhone: null,
        contactPersonNames: null,
        contactPersonIDNo: null,
        businessRole: null,
        contactPersonPhone: null,
        contactPersonEmail: null,
        fullNames: null,
        ownerID: null,
        ownerPhone: null,
        ownerEmail: null,
        kraPin: null,
        createdBy: null,
        createdByIDNo: null,
        dateCreated: null,
        lat: 0.0,
        lng: 0.0
      },
      comments: '',
      search: '',
      paymentMode: '',
      pendingInvoicing: [{
        statusID: null,
        businessID: null,
        businessName: null,
        billNo: null,
        billTotal: null,
        dateCreated: null,
        feeDescription: null,
        names: null,
        stageStatus: null,
      }],
      totalBusiness: 0,
      totalAmount: 0,
      business: {},
      billDetail: {},
      billDetails: {},
      billInfo: {},
      checkedItems: [],
      totalFeeAmountOthers: 0,
      feesAndChargesOthers: [],
      feesAndCharge: {},
      feesAndCharges: {},
      feesAndChargess: [],
      statuses: [],
      tradeCategories: [],
      tradeCategory: {},
      subCounties: [],
      wards: [],
      incomeTypes: [],
      loading: false,
      billCreated: false,
      paymentData: {
        amount: 0,
        accNo: '',
        sessionNames: '',
        sessionIdNo: '',
        sessionPhoneNumber: '',
        phoneNumber: '',
        bankReceiptNo: '',
        eCitizenReceiptNo: '',
        paymentMode: ''
      },
      paymentMethod: false,
      paymentPanel: false,
      transactionSummary: false,
      transactionCompleted: false,
      timer: null,
      rate: null,
      phoneNumber: '',
      receiptDetails: {},
      searchTimeout: null,
      // Pagination and UI properties
      selectedItems: [],
      selectedFilter: '',
      currentPage: 1,
      pageSize: 25,
      filteredData: [],
      entry: {},
      // Server-side pagination properties
      totalPages: 1,
      totalRecords: 0,
      hasNextPage: false,
      hasPreviousPage: false,
      businessNotFound: false,
      // CSV Export properties
      showExportModal: false,
      showProgressModal: false,
      exportType: 'current',
      isExporting: false,
      dateRange: {
        startDate: '',
        endDate: ''
      },
      // Date filter for main table
      filterDateRange: {
        startDate: '',
        endDate: ''
      },
      exportProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        timeRemaining: 'Calculating...',
        currentBatch: 0,
        totalBatches: 0,
        canCancel: true,
        startTime: null
      },
      exportCancelled: false
    };
  },
  mounted() {
    // Load initial data
    this.getPendingApproval(1);
    this.getSubCounties();
    this.getIncomeTypes();
  },
  watch: {
    search: {
      handler(newVal) {
        // Debounce search to avoid too many API calls
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          this.performSearch();
        }, 500);
      }
    },
    selectedFilter: {
      handler(newVal) {
        // Apply frontend filter for categories
        this.applyFrontendFilters();
      }
    },
    pageSize: {
      handler(newVal) {
        // When page size changes, reset to page 1 and fetch
        this.currentPage = 1;
        this.getPendingApproval(1);
      }
    },
    showExportModal(val) {
      if (val) {
        setTimeout(() => {
          const modal = new bootstrap.Modal(document.getElementById('exportModal'));
          modal.show();
        }, 100);
      }
    },
    showProgressModal(val) {
      if (val) {
        setTimeout(() => {
          const modal = new bootstrap.Modal(document.getElementById('exportProgressModal'));
          modal.show();
        }, 100);
      }
    }
  },
  computed: {
    paginatedData() {
      // For server-side pagination, just return the filtered data
      return this.filteredData;
    },
    displayedPages() {
      const pages = [];
      const maxPages = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxPages / 2));
      let end = Math.min(this.totalPages, start + maxPages - 1);

      if (end - start < maxPages - 1) {
        start = Math.max(1, end - maxPages + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
    showingStart() {
      return ((this.currentPage - 1) * this.pageSize) + 1;
    },
    showingEnd() {
      return Math.min(this.currentPage * this.pageSize, this.totalRecords);
    }
  },
  methods: {
    getRight,
    numberFormat(value) {
      if (!value) return '0';
      return new Intl.NumberFormat('en-US').format(value);
    },
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('DD MMM YYYY');
    },
    formattedTime(date) {
      if (!date) return '';
      return moment(date).format('h:mm A');
    },
    formatTimeAgo(date) {
      if (!date) return '';
      return moment(date).fromNow();
    },

    // Existing methods...
    getPendingApproval(page = 1, resetSearch = false) {
      this.loading = true;

      // Reset search if needed
      if (resetSearch) {
        this.search = '';
        this.selectedFilter = '';
        this.filterDateRange.startDate = '';
        this.filterDateRange.endDate = '';
      }

      const data = new FormData();
      data.append("function", "getPendingApproval");
      data.append("keyword", this.search);
      data.append("statusID", "5");
      data.append("page", page);
      data.append("limit", this.pageSize);

      // Add date range parameters if set
      if (this.filterDateRange.startDate) {
        data.append("startDate", this.filterDateRange.startDate);
      }
      if (this.filterDateRange.endDate) {
        data.append("endDate", this.filterDateRange.endDate);
      }

      execute(data, health)
          .then((res) => {
            if (res.data.success) {
              // Update data from server
              this.pendingInvoicing = res.data.data.pendingInvoicing || [];

              // Update pagination info from server
              const pagination = res.data.data.pagination;
              if (pagination) {
                this.currentPage = pagination.currentPage;
                this.totalPages = pagination.totalPages;
                this.totalRecords = pagination.totalRecords;
                this.hasNextPage = pagination.hasNextPage;
                this.hasPreviousPage = pagination.hasPreviousPage;
              }

              // Update summary from server
              const summary = res.data.data.summary;
              if (summary) {
                this.totalBusiness = summary.totalBusinesses;
                this.totalAmount = summary.totalAmount;
              }

              // For frontend filtering (if still needed for category filter)
              this.filteredData = [...this.pendingInvoicing];
              this.applyFrontendFilters();
            } else {
              this.message = res.data.message;
              this.pendingInvoicing = [];
              this.filteredData = [];
              this.totalBusiness = 0;
              this.totalAmount = 0;
            }
            this.loading = false;
          })
          .catch((e) => {
            this.message = e.message;
            this.loading = false;
            this.pendingInvoicing = [];
            this.filteredData = [];
          });
    },

    // Apply frontend filters (for category filter that's not in backend)
    applyFrontendFilters() {
      let filtered = [...this.pendingInvoicing];

      // Apply category filter on frontend
      if (this.selectedFilter) {
        filtered = filtered.filter(item =>
            item.feeDescription?.includes(this.selectedFilter)
        );
      }

      this.filteredData = filtered;
    },

    // Date filter methods
    applyDateFilter() {
      // Validate date range
      if (this.filterDateRange.startDate && this.filterDateRange.endDate) {
        if (new Date(this.filterDateRange.startDate) > new Date(this.filterDateRange.endDate)) {
          alert('Start date must be before end date');
          return;
        }
      }

      // Reset to first page and fetch with date filter
      this.currentPage = 1;
      this.getPendingApproval(1);
    },

    clearDateFilter() {
      this.filterDateRange.startDate = '';
      this.filterDateRange.endDate = '';
      this.currentPage = 1;
      this.getPendingApproval(1);
    },

    // Search with debounce
    performSearch() {
      this.currentPage = 1;
      this.getPendingApproval(1);
    },

    // Filter data based on category
    filterData() {
      this.applyFrontendFilters();
    },

    // Pagination methods
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getPendingApproval(page);
      }
    },

    previousPage() {
      if (this.hasPreviousPage && this.currentPage > 1) {
        this.currentPage--;
        this.getPendingApproval(this.currentPage);
      }
    },

    nextPage() {
      if (this.hasNextPage && this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getPendingApproval(this.currentPage);
      }
    },

    updatePageSize() {
      // This is now handled in the watch for pageSize
    },

    // Selection methods
    selectAll(event) {
      if (event.target.checked) {
        this.selectedItems = this.paginatedData.map(item => item.billNo);
      } else {
        this.selectedItems = [];
      }
    },

    // Status badge styling
    getStatusBadgeClass(status) {
      switch(status?.toLowerCase()) {
        case 'approved':
          return 'bg-success';
        case 'pending':
          return 'bg-warning';
        case 'rejected':
          return 'bg-danger';
        case 'active':
          return 'bg-success';
        default:
          return 'bg-secondary';
      }
    },

    // CSV Export methods
    closeExportModal() {
      if (!this.isExporting) {
        this.showExportModal = false;
        this.exportType = 'current';
        this.dateRange.startDate = '';
        this.dateRange.endDate = '';

        const modal = bootstrap.Modal.getInstance(document.getElementById('exportModal'));
        if (modal) modal.hide();
      }
    },

    async startExport() {
      if (this.exportType === 'current') {
        this.exportCurrentPage();
      } else if (this.exportType === 'all') {
        await this.exportAllRecords();
      } else if (this.exportType === 'dateRange') {
        if (!this.dateRange.startDate || !this.dateRange.endDate) {
          alert('Please select both start and end dates');
          return;
        }
        if (new Date(this.dateRange.startDate) > new Date(this.dateRange.endDate)) {
          alert('Start date must be before end date');
          return;
        }
        await this.exportDateRange();
      }
    },

    exportCurrentPage() {
      const csvData = this.convertToCSV(this.paginatedData);
      this.downloadCSV(csvData, `hygiene-certificates-page-${this.currentPage}-${this.getCurrentDateString()}.csv`);
      this.closeExportModal();
    },

    async exportAllRecords() {
      this.showExportModal = false;
      const modal = bootstrap.Modal.getInstance(document.getElementById('exportModal'));
      if (modal) modal.hide();

      this.showProgressModal = true;
      this.isExporting = true;
      this.exportCancelled = false;

      const batchSize = 50;
      const totalRecords = this.totalRecords;
      const totalBatches = Math.ceil(totalRecords / batchSize);

      this.exportProgress.total = totalRecords;
      this.exportProgress.current = 0;
      this.exportProgress.percentage = 0;
      this.exportProgress.totalBatches = totalBatches;
      this.exportProgress.currentBatch = 0;
      this.exportProgress.startTime = Date.now();
      this.exportProgress.canCancel = true;

      let allRecords = [];

      try {
        for (let batch = 1; batch <= totalBatches; batch++) {
          if (this.exportCancelled) {
            break;
          }

          this.exportProgress.currentBatch = batch;

          const data = new FormData();
          data.append("function", "getPendingApproval");
          data.append("statusID", "5  ");
          data.append("page", batch);
          data.append("limit", batchSize);

          if (this.search) {
            data.append("keyword", this.search);
          }

          // Include active date filters in export
          if (this.filterDateRange.startDate) {
            data.append("startDate", this.filterDateRange.startDate);
          }
          if (this.filterDateRange.endDate) {
            data.append("endDate", this.filterDateRange.endDate);
          }

          const res = await execute(data, health);

          if (res.data.success && res.data.data.pendingInvoicing) {
            allRecords = allRecords.concat(res.data.data.pendingInvoicing);
            this.exportProgress.current = allRecords.length;
            this.exportProgress.percentage = Math.round((this.exportProgress.current / this.exportProgress.total) * 100);

            // Calculate time remaining
            const elapsed = Date.now() - this.exportProgress.startTime;
            const rate = this.exportProgress.current / elapsed;
            const remaining = this.exportProgress.total - this.exportProgress.current;
            const remainingMs = remaining / rate;
            this.exportProgress.timeRemaining = this.formatTimeRemaining(remainingMs);
          }

          // Small delay to prevent overwhelming the server
          await new Promise(resolve => setTimeout(resolve, 100));
        }

        if (!this.exportCancelled && allRecords.length > 0) {
          this.exportProgress.canCancel = false;
          this.exportProgress.timeRemaining = 'Generating CSV file...';

          const csvData = this.convertToCSV(allRecords);
          this.downloadCSV(csvData, `hygiene-certificates-all-${this.getCurrentDateString()}.csv`);

          setTimeout(() => {
            this.showProgressModal = false;
            const progressModal = bootstrap.Modal.getInstance(document.getElementById('exportProgressModal'));
            if (progressModal) progressModal.hide();
            this.isExporting = false;
            alert(`Successfully exported ${allRecords.length} records!`);
          }, 500);
        } else if (this.exportCancelled) {
          this.showProgressModal = false;
          const progressModal = bootstrap.Modal.getInstance(document.getElementById('exportProgressModal'));
          if (progressModal) progressModal.hide();
          this.isExporting = false;
          alert('Export cancelled');
        }
      } catch (error) {
        console.error('Export error:', error);
        this.showProgressModal = false;
        const progressModal = bootstrap.Modal.getInstance(document.getElementById('exportProgressModal'));
        if (progressModal) progressModal.hide();
        this.isExporting = false;
        alert('Error during export. Please try again.');
      }
    },

    async exportDateRange() {
      this.showExportModal = false;
      const modal = bootstrap.Modal.getInstance(document.getElementById('exportModal'));
      if (modal) modal.hide();

      this.showProgressModal = true;
      this.isExporting = true;
      this.exportCancelled = false;

      const batchSize = 50;

      this.exportProgress.total = 0;
      this.exportProgress.current = 0;
      this.exportProgress.percentage = 0;
      this.exportProgress.currentBatch = 0;
      this.exportProgress.startTime = Date.now();
      this.exportProgress.canCancel = true;
      this.exportProgress.timeRemaining = 'Fetching data...';

      let allRecords = [];
      let batch = 1;
      let hasMore = true;

      try {
        while (hasMore && !this.exportCancelled) {
          this.exportProgress.currentBatch = batch;

          const data = new FormData();
          data.append("function", "getPendingApproval");
          data.append("statusID", "5");
          data.append("page", batch);
          data.append("limit", batchSize);
          data.append("startDate", this.dateRange.startDate);
          data.append("endDate", this.dateRange.endDate);

          if (this.search) {
            data.append("keyword", this.search);
          }

          const res = await execute(data, health);

          if (res.data.success && res.data.data.pendingInvoicing && res.data.data.pendingInvoicing.length > 0) {
            allRecords = allRecords.concat(res.data.data.pendingInvoicing);
            this.exportProgress.current = allRecords.length;

            // Update total if we have pagination info
            if (res.data.data.pagination && res.data.data.pagination.totalRecords) {
              this.exportProgress.total = res.data.data.pagination.totalRecords;
              this.exportProgress.percentage = Math.round((this.exportProgress.current / this.exportProgress.total) * 100);
              this.exportProgress.totalBatches = res.data.data.pagination.totalPages;

              // Calculate time remaining
              const elapsed = Date.now() - this.exportProgress.startTime;
              const rate = this.exportProgress.current / elapsed;
              const remaining = this.exportProgress.total - this.exportProgress.current;
              const remainingMs = remaining / rate;
              this.exportProgress.timeRemaining = this.formatTimeRemaining(remainingMs);
            }

            hasMore = res.data.data.pagination.hasNextPage;
            batch++;
          } else {
            hasMore = false;
          }

          await new Promise(resolve => setTimeout(resolve, 100));
        }

        if (!this.exportCancelled && allRecords.length > 0) {
          this.exportProgress.canCancel = false;
          this.exportProgress.timeRemaining = 'Generating CSV file...';

          const csvData = this.convertToCSV(allRecords);
          this.downloadCSV(csvData, `hygiene-certificates-${this.dateRange.startDate}-to-${this.dateRange.endDate}.csv`);

          setTimeout(() => {
            this.showProgressModal = false;
            const progressModal = bootstrap.Modal.getInstance(document.getElementById('exportProgressModal'));
            if (progressModal) progressModal.hide();
            this.isExporting = false;
            alert(`Successfully exported ${allRecords.length} records!`);
          }, 500);
        } else if (this.exportCancelled) {
          this.showProgressModal = false;
          const progressModal = bootstrap.Modal.getInstance(document.getElementById('exportProgressModal'));
          if (progressModal) progressModal.hide();
          this.isExporting = false;
          alert('Export cancelled');
        } else {
          this.showProgressModal = false;
          const progressModal = bootstrap.Modal.getInstance(document.getElementById('exportProgressModal'));
          if (progressModal) progressModal.hide();
          this.isExporting = false;
          alert('No records found for the selected date range');
        }
      } catch (error) {
        console.error('Export error:', error);
        this.showProgressModal = false;
        const progressModal = bootstrap.Modal.getInstance(document.getElementById('exportProgressModal'));
        if (progressModal) progressModal.hide();
        this.isExporting = false;
        alert('Error during export. Please try again.');
      }
    },

    cancelExport() {
      this.exportCancelled = true;
      this.exportProgress.canCancel = false;
    },

    convertToCSV(data) {
      if (!data || data.length === 0) return '';

      const headers = [
        'Bill No',
        'Business ID',
        'Business Name',
        'Owner Name',
        'Fee Description',
        'Amount (KES)',
        'Date Created',
        'Status',
        'Stage Status'
      ];

      const csvRows = [];
      csvRows.push(headers.join(','));

      data.forEach(record => {
        const row = [
          this.escapeCsvValue(record.billNo),
          this.escapeCsvValue(record.businessID),
          this.escapeCsvValue(record.businessName),
          this.escapeCsvValue(record.names),
          this.escapeCsvValue(record.feeDescription),
          record.billTotal || 0,
          record.dateCreated || '',
          this.getStatusLabel(record.statusID),
          this.escapeCsvValue(record.stageStatus)
        ];
        csvRows.push(row.join(','));
      });

      return csvRows.join('\n');
    },

    getStatusLabel(statusID) {
      const statusMap = {
        '5': 'Active',
        '1': 'Pending',
        '2': 'Approved',
        '3': 'Rejected'
      };
      return statusMap[statusID] || 'Active';
    },

    escapeCsvValue(value) {
      if (value === null || value === undefined) return '';
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      return stringValue;
    },

    downloadCSV(csvData, filename) {
      const BOM = '\uFEFF';
      const blob = new Blob([BOM + csvData], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    },

    formatTimeRemaining(ms) {
      if (!ms || ms < 0) return 'Calculating...';

      const seconds = Math.floor(ms / 1000);

      if (seconds < 60) {
        return `${seconds} seconds`;
      } else if (seconds < 3600) {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}m ${secs}s`;
      } else {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        return `${hours}h ${minutes}m`;
      }
    },

    getCurrentDateString() {
      return new Date().toISOString().split('T')[0];
    },

    // Export functions
    exportToExcel() {
      // Show CSV export modal instead
      this.showExportModal = true;
    },

    exportToPDF() {
      // Implement PDF export
      alert('PDF export feature coming soon...');
    },

    // Bulk actions
    bulkPrintInvoices() {
      this.selectedItems.forEach(billNo => {
        this.printBill(billNo);
      });
    },

    bulkSendSMS() {
      // Implement bulk SMS sending
      alert(`Sending SMS to ${this.selectedItems.length} businesses...`);
    },

    // Communication methods
    sendSMS(item) {
      // Open SMS modal with item details
      this.business = item;
      this.billDetail = { billNo: item.billNo };
      const smsModal = new bootstrap.Modal(document.getElementById('invoiceSMSModal'));
      smsModal.show();
    },

    sendEmail(item) {
      // Implement email sending
      alert(`Sending email to ${item.businessName}`);
    },

    getBusiness(item) {
      this.entry = item;
      this.getBusinessDetails(item.businessID, item.billNo, item.feeID);
    },

    getBusinessDetails(businessID, billNo, feeID) {
      const data = new FormData();
      data.append("function", "getBusiness");
      data.append("businessID", businessID);
      data.append("billNo", billNo);

      execute(data, health)
          .then((res) => {
            if (res.data.success) {
              this.businessDetails = res.data.data.business;
              this.billDetails = res.data.data.bill.billDetails;
              this.billInfo = res.data.data.bill.billInfo;

              this.business = res.data.data.business;
              this.billDetail = res.data.data.bill.billDetails;

              this.paymentData.amount = res.data.data.bill.billDetails.billBalance;
              this.paymentData.accNo = res.data.data.bill.billDetails.billNo;
              this.paymentData.sessionNames = sessionStorage.getItem("sessionNames");
              this.paymentData.sessionIdNo = sessionStorage.getItem("sessionIdNo");
              this.paymentData.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber");

              if (this.businessDetails.subCountyID) {
                this.getWards(this.businessDetails.subCountyID, this.businessDetails.subCountyName);
              }

              if (this.businessDetails.incomeTypeID) {
                this.getFeesAndCharges(this.businessDetails.incomeTypeID);

                if (this.businessDetails.feeID) {
                  this.feesAndCharge = {
                    id: this.businessDetails.feeID,
                    feeDescription: this.businessDetails.feeDescription,
                    feeAmount: this.businessDetails.amount || this.businessDetails.newAmount
                  };
                }
              }
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              let rawSubCounties = [];
              if (Array.isArray(res.data.data)) {
                rawSubCounties = res.data.data;
              } else if (res.data.data?.subCounties) {
                rawSubCounties = res.data.data.subCounties;
              }

              this.subCounties = Array.isArray(rawSubCounties) ? rawSubCounties : [];
            } else {
              this.subCounties = [];
            }
          })
          .catch((e) => {
            this.subCounties = [];
            this.message = e.message;
          });
    },

    getWards(subCountyID, subCountyName) {
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", subCountyID);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              let rawWards = [];
              if (Array.isArray(res.data.data)) {
                rawWards = res.data.data;
              } else if (res.data.data?.wards) {
                rawWards = res.data.data.wards;
              }

              this.wards = Array.isArray(rawWards) ? rawWards : [];
            } else {
              this.wards = [];
            }
          })
          .catch((e) => {
            this.wards = [];
            this.message = e.message;
          });
    },

    getIncomeTypes() {
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              let rawIncomeTypes = [];
              if (Array.isArray(res.data.data)) {
                rawIncomeTypes = res.data.data;
              } else if (res.data.data?.incomeTypes) {
                rawIncomeTypes = res.data.data.incomeTypes;
              }

              this.incomeTypes = rawIncomeTypes;
            } else {
              this.incomeTypes = [];
            }
          })
          .catch((e) => {
            this.incomeTypes = [];
            this.message = e.message;
          });
    },

    getFeesAndCharges(incomeTypeId) {
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", incomeTypeId);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              let rawFees = [];
              let rawOthers = [];

              if (res.data.data?.feesAndCharges) {
                rawFees = res.data.data.feesAndCharges;
                rawOthers = res.data.data.feesAndChargesOthers || [];
              } else if (Array.isArray(res.data.data)) {
                rawFees = res.data.data;
                rawOthers = [];
              }

              this.feesAndChargess = rawFees;
              this.feesAndChargesOthers = rawOthers;
            } else {
              this.feesAndChargess = [];
              this.feesAndChargesOthers = [];
            }
          })
          .catch((e) => {
            this.feesAndChargess = [];
            this.feesAndChargesOthers = [];
            this.message = e.message;
          });
    },

    calculateTotal() {
      // Implement calculation logic
    },

    openTopUpModal(businessID, billNo, feeID) {
      this.getBusinessDetails(businessID, billNo, feeID);

      this.checkedItems = [];
      this.totalFeeAmountOthers = 0;
      this.billCreated = false;
    },

    viewBusiness(value) {
      // Handle view business logic from TopUpModal
    },

    updateBusinessTopUp() {
      this.loading = true;
      this.invoice = true;

      const selectedSubCounty = this.subCounties.find(
          sc => String(sc.subCountyID) === String(this.subCounty?.subCountyID || this.businessDetails.subCountyID)
      );

      const selectedWard = this.wards.find(
          w => String(w.wardID) === String(this.ward?.wardID || this.businessDetails.wardID)
      );

      const subCountyName = selectedSubCounty?.subCountyName || this.businessDetails.subCountyName || '';
      const subCountyID = selectedSubCounty?.subCountyID || this.businessDetails.subCountyID || '';
      const wardName = selectedWard?.wardName || this.businessDetails.wardName || '';
      const wardID = selectedWard?.wardID || this.businessDetails.wardID || '';

      const currentYear = new Date().getFullYear();
      const yearValue = this.year?.year || this.billDetail?.fiscalYear || this.billDetails?.fiscalYear || currentYear;

      const data = new FormData();
      data.append("function", "updateBusinessTopUp");
      data.append("businessName", this.businessDetails.businessName);
      data.append("kraPin", this.businessDetails.kraPin || '');
      data.append("fullNames", this.businessDetails.fullNames || '');
      data.append("postalAddress", this.businessDetails.postalAddress || '');
      data.append("plotNumber", this.businessDetails.plotNumber || '');
      data.append("subCountyName", subCountyName);
      data.append("subCountyID", subCountyID);
      data.append("wardName", wardName);
      data.append("wardID", wardID);
      data.append("physicalAddress", this.businessDetails.physicalAddress || '');
      data.append("billNo", this.prevBillNo || this.billDetail?.billNo || '');
      data.append("year", yearValue);
      data.append("businessID", this.businessDetails.businessID);
      data.append("ownerPhone", this.businessDetails.ownerPhone || '');
      data.append("ownerID", this.businessDetails.ownerID || '');
      data.append("businessDes", this.businessDetails.businessDes || '');
      data.append("feeId", this.feesAndCharge.feeId || this.feesAndCharge.id || '');
      data.append("prevFeeID", this.prevFeeID || this.businessDetails.feeID || '');
      data.append("sessionPhoneNumber", sessionStorage.getItem("sessionPhoneNumber"));
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      data.append("selectedItems", JSON.stringify(this.checkedItems));
      const unitFee1 = Number(this.feesAndCharge?.unitFeeAmount || this.feesAndCharge?.feeAmount) || 0;
      const unitFee2 = Number(this.feesAndCharges?.unitFeeAmount || this.feesAndCharges?.feeAmount) || 0;

      data.append("amount", unitFee1 - unitFee2);

      execute(data, biller)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.billCreated = true;
              this.billNo = res.data.data.billDetails.billNo;

              this.billDetails = res.data.data.billDetails;

              this.paymentData.amount = this.billDetails.billBalance;
              this.paymentData.accNo = this.billDetails.billNo;
              this.paymentData.sessionNames = sessionStorage.getItem("sessionNames");
              this.paymentData.sessionIdNo = sessionStorage.getItem("sessionIdNo");
              this.paymentData.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber");

            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
          });
    },

    updateCheckedItems(items) {
      this.checkedItems = items;
      this.totalFeeAmountOthers = items.reduce((sum, item) => sum + (item.unitFeeAmount || 0), 0);
    },

    resendMessage() {
      alert('SMS resent successfully');
    },

    printBill(billNo) {
      localStorage['params'] = JSON.stringify({
        billNo: billNo
      });
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },

    printBill2() {
      this.printBill(this.billDetails.billNo);
    },

    printPermit(businessID) {
      const data = new FormData();
      data.append("function", "printPermit");
      data.append("businessID", businessID);

      execute(data, health)
          .then((res) => {
            if (res.data.success) {
              localStorage['params'] = JSON.stringify({
                businessID: businessID
              });
              const routeData = this.$router.resolve({name: 'health-permit'});
              window.open(routeData.href, '_blank');
            } else {
              alert('Business not found or permit not available');
              this.businessNotFound = true;
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    printReceipt() {
      localStorage['params'] = JSON.stringify({
        receiptNo: this.receiptDetails.receiptNo || this.receiptDetails.transactionCode,
        billNo: this.receiptDetails.billNo
      });
      const routeData = this.$router.resolve({name: 'receipt'});
      window.open(routeData.href, '_blank');
    },

    closeAllModals() {
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach(modal => {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
      });
    },

    showPaymentMethod() {
      this.closeAllModals();
      this.paymentMethod = true;
      this.paymentPanel = false;
      this.transactionSummary = false;
      this.transactionCompleted = false;

      if (this.billDetails && this.billDetails.billNo && this.billDetails.billBalance) {
        this.paymentData.amount = parseFloat(this.billDetails.billBalance);
        this.paymentData.accNo = this.billDetails.billNo;

      } else {
        if (this.billDetail && this.billDetail.billNo && this.billDetail.billBalance) {
          this.paymentData.amount = parseFloat(this.billDetail.billBalance);
          this.paymentData.accNo = this.billDetail.billNo;

        } else {
          alert('Payment data not available. Please try again.');
          return;
        }
      }

      this.paymentData.sessionNames = sessionStorage.getItem("sessionNames");
      this.paymentData.sessionIdNo = sessionStorage.getItem("sessionIdNo");
      this.paymentData.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber");

      const paymentModal = new bootstrap.Modal(document.getElementById('payment-modal'));
      paymentModal.show();
    },

    updatePhoneNumber(phoneNumber) {
      this.phoneNumber = phoneNumber;
      this.paymentData.phoneNumber = phoneNumber;
    },

    handleShowTransactionSummary(paymentDataFromModal) {
      this.paymentData = { ...this.paymentData, ...paymentDataFromModal };
      this.paymentMethod = false;
      this.paymentPanel = false;
      this.transactionSummary = true;
      this.transactionCompleted = false;
    },

    handleMakePayment(paymentDataFromModal) {
      this.paymentData = { ...this.paymentData, ...paymentDataFromModal };
      this.makePayment();
    },

    makePayment() {
      if (this.paymentData.paymentMode === "MPESA") {
        if (this.paymentData.phoneNumber == null || this.paymentData.phoneNumber === '') {
          alert("Enter phone number");
          return;
        }
      }

      if (this.paymentData.paymentMode === "BANK") {
        if (this.paymentData.bankReceiptNo == null || this.paymentData.bankReceiptNo === '') {
          alert("Enter Bank Receipt No");
          return;
        }
      }

      if (this.paymentData.paymentMode === "E-CITIZEN") {
        if (this.paymentData.eCitizenReceiptNo == null || this.paymentData.eCitizenReceiptNo === '') {
          alert("Enter E-CITIZEN Receipt No");
          return;
        }
      }

      this.message = "Payment Request sent";

      const data = new FormData();
      data.append("function", "makePayment");
      data.append("paymentData", JSON.stringify(this.paymentData));

      let stream = biller;
      if (this.paymentData.accNo.startsWith("SBP")) {
        stream = trade;
      }
      if (this.paymentData.accNo.startsWith("PKN")) {
        stream = parking;
      }
      if (this.paymentData.accNo.startsWith("RNT")) {
        stream = rent;
      }
      if (this.paymentData.accNo.startsWith("BLL")) {
        stream = biller;
      }
      if (this.paymentData.accNo.startsWith("HYG")) {
        stream = health;
      }

      execute(data, stream)
          .then((res) => {
            if (res.data.success) {
              this.paymentMethod = false;
              this.paymentPanel = false;
              this.timer = setInterval(() => {
                this.checkPayment();
              }, 3000);
            } else {
              this.rate = null;
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    checkPayment() {
      const data = new FormData();
      data.append("function", "checkPayment");
      data.append("billNo", this.paymentData.accNo);

      let stream = health;
      if (this.paymentData.accNo.startsWith("HYG")) {
        stream = health;
      }

      execute(data, stream)
          .then((res) => {
            if (res.data.success) {
              if (res.data.data.paid) {
                clearInterval(this.timer);
                this.receiptDetails = res.data.data.receiptDetails;
                this.transactionSummary = false;
                this.transactionCompleted = true;
                this.getPendingApproval();
              }
            }
          })
          .catch((e) => {
            console.error('Error checking payment:', e.message);
          });
    }
  }
}
</script>

<style scoped>
/* Enhanced UI Styles */
.mini-stats-wid .card-body {
  padding: 20px;
}

.mini-stat-icon {
  width: 48px;
  height: 48px;
}

.hover-row {
  transition: all 0.3s ease;
  cursor: pointer;
}

.hover-row:hover {
  background-color: #f8f9fa !important;
  transform: translateX(2px);
}

.selected-row {
  background-color: #e7f3ff !important;
}

.btn-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.18);
  border: none;
}

.btn-soft-primary:hover {
  color: #fff;
  background-color: #556ee6;
}

.btn-soft-success {
  color: #34c38f;
  background-color: rgba(52, 195, 143, 0.18);
  border: none;
}

.btn-soft-success:hover {
  color: #fff;
  background-color: #34c38f;
}

.btn-soft-info {
  color: #50a5f1;
  background-color: rgba(80, 165, 241, 0.18);
  border: none;
}

.btn-soft-info:hover {
  color: #fff;
  background-color: #50a5f1;
}

.btn-soft-secondary {
  color: #74788d;
  background-color: rgba(116, 120, 141, 0.18);
  border: none;
}

.btn-soft-secondary:hover {
  color: #fff;
  background-color: #74788d;
}

.badge {
  padding: 0.5em 0.75em;
  font-weight: 500;
}

.bg-info-subtle {
  background-color: rgba(80, 165, 241, 0.18);
  color: #50a5f1;
}

.table > :not(caption) > * > * {
  padding: 0.75rem;
}

.avatar-sm {
  height: 2.5rem;
  width: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.bg-light {
  background-color: #f3f3f9 !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,0.075);
  border: none;
}

.card-header {
  background-color: #fff;
  border-bottom: 1px solid #eff2f7;
}

.card-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #eff2f7;
}

.pagination {
  margin-bottom: 0;
}

.page-link {
  color: #556ee6;
  border: 1px solid #dee2e6;
}

.page-item.active .page-link {
  background-color: #556ee6;
  border-color: #556ee6;
}

.dataTables_info {
  color: #74788d;
  font-weight: 500;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.form-check-input:checked {
  background-color: #556ee6;
  border-color: #556ee6;
}

.dropdown-menu {
  box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.15);
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

.gap-1 {
  gap: 0.25rem;
}

.font-size-64 {
  font-size: 64px;
}

.font-size-20 {
  font-size: 20px;
}

.font-size-24 {
  font-size: 24px;
}

.font-size-14 {
  font-size: 14px;
}

.font-size-12 {
  font-size: 12px;
}

/* Search input styling */
.app-search .form-control {
  border: 1px solid #ced4da;
  padding-left: 40px;
}

.app-search .bx-search-alt {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #74788d;
}

/* Export Modal Styles */
.export-options .form-check {
  cursor: pointer;
  transition: all 0.3s ease;
}

.export-options .form-check:hover {
  border-color: #556ee6 !important;
}

.export-options .form-check.bg-light {
  background-color: #e7f3ff !important;
  border-color: #556ee6 !important;
}

.export-info {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
}

.progress {
  border-radius: 8px;
}

.progress-bar {
  font-size: 14px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.875rem;
  }

  .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }

  .card-body {
    padding: 1rem;
  }

  .d-flex.align-items-center {
    flex-wrap: wrap;
    gap: 10px;
  }
}
</style>